import { z } from "zod";
import { optional } from "./appointments";
import { adminPassword, personPhone } from "./admin-people";
import { searchTextUpTo } from "./fields";
import { memberListQuery } from "./organization-members";
import { emailAddress, settingsName } from "./organization-settings";

const SEARCH_MAX_LENGTH = 200;

export const grantedRole = z.enum(["admin", "propertyManager"]);
export type GrantedMembershipRole = z.infer<typeof grantedRole>;

export const adminMemberListQuery = memberListQuery.extend({ search: optional(searchTextUpTo(SEARCH_MAX_LENGTH)) });
export type AdminMemberListQuery = z.infer<typeof adminMemberListQuery>;

export const adminMemberAddRequest = z
  .object({
    name: settingsName,
    email: emailAddress,
    role: grantedRole,
    password: optional(adminPassword),
    phone: personPhone,
  })
  .strict();
export type AdminMemberAddRequest = { name: string; email: string; role: GrantedMembershipRole; password?: string; phone?: string | null };
